import { useEffect } from 'react';

/* eslint-disable jsx-a11y/anchor-is-valid */
import Button from '@components/Button';
import Sidebar from '@components/Sidebar';

import { pushAddToCartToDataLayer } from '@utilities/helpers/common';
import { Sidebar as SidebarClass } from '@features/Checkout/components/CheckoutSteps/CheckoutSteps.module.css';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';
import NoSsr from '@components/NoSsr/NoSsr';
import { useTranslation } from 'next-i18next';

import {
  Root,
  CheckoutButton,
  FixedButtonOnMobile,
} from './CheckoutSidebar.module.css';
import OrderSummary from '../OrderSummary';
import { setFormIsValid, setIsValidating } from '@features/Checkout/store';

const CheckoutSidebar = ({
  children,
  buttonText,
  noButton,
  fixedButtonOnMobile,
  animate,
  contentBelowButton,
  proceedDisabled,
  membershipStepComplete,
  memberships,
  checkoutPrice,
  isLoading: isLoadingSummary,
  couponCode,
  isInformationStep,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation(['account', 'common', 'checkout']);
  const { formIsValid, formIsValidating, isLoading, errorComponent } =
    useSelector((state) => state.checkout);
  const {
    options: { currencyCode },
  } = useSelector((state) => state.wordpress);

  useEffect(() => {
    if (isInformationStep) {
      dispatch(setFormIsValid(true));
      dispatch(setIsValidating(false));
    }
  }, [isInformationStep, dispatch]);

  useEffect(() => {
    if (
      membershipStepComplete &&
      memberships &&
      buttonText &&
      buttonText === t('next', { ns: 'common' })
    ) {
      pushAddToCartToDataLayer(
        memberships,
        checkoutPrice,
        currencyCode,
        couponCode
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [membershipStepComplete]);

  return (
    <Sidebar
      className={classNames(
        SidebarClass,
        {
          [FixedButtonOnMobile]: fixedButtonOnMobile,
        },
        Root
      )}
    >
      <OrderSummary
        animate={animate}
        fixedTotalsOnMobile={fixedButtonOnMobile}
        forceStickToBottom={noButton}
        memberships={memberships}
        checkoutPrice={checkoutPrice}
        isLoading={isLoadingSummary}
      />
      {children}
      <NoSsr>
        {!noButton && (
          <Button
            className={CheckoutButton}
            appearance={!formIsValid || errorComponent ? 'dark' : 'primary'}
            size="extra-large"
            noIconAnimation={!formIsValid || Boolean(errorComponent)}
            isLoading={isLoadingSummary || isLoading || formIsValidating}
            disabled={
              proceedDisabled ||
              isLoading ||
              isLoadingSummary ||
              formIsValidating ||
              Boolean(errorComponent)
            }
            fullWidth
            type="submit"
          >
            {buttonText || t('next', { ns: 'common' })}
          </Button>
        )}
        {contentBelowButton}
      </NoSsr>
    </Sidebar>
  );
};

CheckoutSidebar.defaultProps = {
  buttonText: '',
  noButton: false,
  fixedButtonOnMobile: false,
  animate: false,
  proceedDisabled: false,
};

CheckoutSidebar.propTypes = {
  buttonText: PropTypes.string,
  noButton: PropTypes.bool,
  fixedButtonOnMobile: PropTypes.bool,
  animate: PropTypes.bool,
  proceedDisabled: PropTypes.bool,
};

export default CheckoutSidebar;
